import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
// import TestContent from "../views/testContent";
// import WithAgentId from "../views/AgentPages/withAgentId";
// import WithoutAgentId from "../views/AgentPages/withoutAgentId";
import WithAccountNumber from "../views/CustomerPages/withAccountNumber";
import PageNotFound from "../views/pageNotFound";
// import ConstellationEmail from '../views/CustomerPages/constellation';
// import UtilityBilled from "../views/AgentPages/utilityBilled";
// import DirectBilled from "../views/AgentPages/directBilled";
// import EmailWithAccountNumber from "../views/EmailUnsubscribePages/emailWithAccountNumber";
// import EmailUnsubscribeSuccess from "../views/EmailUnsubscribePages/emailUnsubscribeSuccess";
import ResidentialForm from "../views/CustomerPages/ResidentialForm";
import SearchScreen from "../views/CustomerPages/SearchScreen";
import SMBForm from "../views/CustomerPages/SMBForm";

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Router history={createBrowserHistory()}>
        <Switch>
          <Route path="/residential-account" component={ResidentialForm} exact />
          <Route path="/update" component={WithAccountNumber} exact />
          <Route path="/" component={SearchScreen} exact />
          <Route path="/smb-account" component={SMBForm} />
          <Route path="/*" component={PageNotFound} />
        </Switch>
      </Router>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/routes.jsx